import React, { useMemo } from 'react';
import StyledTableBodyRow from './TableBodyRowPaymentAdmin.styles';
import type { AdminPaymentType } from '../../types/userTypes';
import { formattingDate } from '../../utils/formattingDateHelper';

type PropsType = {
  item: AdminPaymentType;
  className?: string;
};

const TableBodyRowPaymentAdmin: React.FC<PropsType> = (props) => {
  const { item, className = '' } = props;

  const correctDisplayInfo = (info: number | string | null) => (info || '-');

  const orderValueArray = useMemo(() => {
    return [
      { content: item.userTransactionId },

      { content: `$${item.amount.toFixed(2)}` },

      { content: item?.user?.email },

      { content: correctDisplayInfo(item.transferType) },

      { content: formattingDate(item.createdAt) },

      { content: item.description },

    ];
  }, [item]);

  return (
    <StyledTableBodyRow className={className}>
      {orderValueArray.map((item, index) => (
        <td key={index}>
          <div>
            {item.content}
          </div>
        </td>
      ))}
    </StyledTableBodyRow>
  );
};

export default TableBodyRowPaymentAdmin;
